<template>
  <div class="container-fluid new_Header" v-if="!isLoading">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('previewlist.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">
              {{$t('previewlist.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
        <mainloader v-if="isLoading" />
        <div v-else class="row pt-3 justify-content-center">
          <div class="col-12 col-md-8 mb-4" v-for="(row,index) in rows" :key="index">
            <router-link  :to="'/previewdetails/'+row.id">
              <div class="card br-radius-16">
                <div class="card-body padding-10">
                  <div class="row">
                    <div class="col-5 col-md-3 button-center">
                      <div class="position-R">
                        <swiper class="width-120" v-if="row.Property.mediaFiles.length" 
                          :modules="modules" 
                          :autoplay="{ delay: 2500,disableOnInteraction: false,}" 
                          :pagination="{ clickable: true }" :navigation="false"
                        > 
                          <swiper-slide v-for="(val, index) in row.Property.mediaFiles" :key="index">
                            <img :src="MEDIA_URL+val.thumbnail" alt="Slide Image" class="img-fluid br-radius" />
                          </swiper-slide>
                        </swiper>
                        <div v-else>
                          <img src="/assets/images/defaultImage.jpg" class="img-fluid br-radius" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="col-7 col-md-9">
                      <div class="row">
                        <div class="col-auto">
                          <div class="reservation-style mb-2 space">
                            {{row.date}}
                            <span class="mx-2">{{ row.time}}</span>
                          </div>
                        </div>
                        <div class="col-auto almarai-bold marginDirection">
                          <!-- <div>{{item.reservationStatus[row.status]}}</div> -->
                          <div :class="(row.status == 'new'|| row.status == 'waiting_payment')? 'status_Style status-New' : 
                            (row.status == 'done')? 'status_Style status-Done': 
                            (row.status == 'canceled_client'|| row.status == 'rejected')? 'status_Style status-Cancel' 
                              :'status_Style status-New'">
                            {{item.reservationStatus[row.status]}}
                          </div>
                        </div>
                      </div>
                      <div class="almarai-regular">{{ row.Property.title }}</div>
                      <div class="row pt-2">
                        <div class="col-auto">
                          <i class="fa-solid fa-location-dot gray-color"></i>
                          <span class="mx-2 gray-color fonttext-14">{{ row.Property.City.name }}</span>
                          <span class="gray-color fonttext-14">{{ row.Property.Neighborhood.name }}</span>
                        </div>
                        <div class="col-auto preview-text">
                          <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                          <span class="green-color-F almarai-bold">{{ row.Property.price }}</span>
                          <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row pt-3 justify-content-center" v-if="!rows.length && !isLoading">
          <div class="col-12">
            <div class="text-center pb-3">
              <img src="/assets/images/icons/Frame-48.png" class="img-fluid" alt="">
            </div>
            <div class="almarai-bold pt-2 text-center">{{$t('previewlist.title_1')}}</div>
            <div class="text-center almarai-regular gray-color fonttext-14">
              <span>{{$t('previewlist.title_2')}}</span>
            </div>
          </div>
          <div class="col-11 col-md-5 text-center py-3">
            <router-link to="/">
              <button class="submit-button form-control almarai-bold">{{$t('previewlist.button')}}</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-5">
      <div class="col">
        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-center mouse-hand">
            <li class="page-item page-link br-radius4" v-if="currentPage > 1" @click.prevent="Prevpage">
              <i class="fa-solid fa-circle-right orange-color mx-2"></i>
              <span>{{$t('previewlist.Previous')}}</span>
            </li>
            <li class="page-item pagination-style">{{currentPage}}</li>
            <li class="page-item page-link br-radius4" v-if="rows && rows.length >= 30"  @click.prevent="Nextpage">
              <span class="mx-2">{{$t('previewlist.Next')}}</span>
              <i class="fa-solid fa-circle-left orange-color"></i>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { mapGetters } from "vuex";
export default {
  name: 'previewlist',
  data(){
    return {
      hasError: false,
      message: "",
      errorNumber: 0,
      isLoading: true,
      rows: [],
      item: {},
      currentPage: 1,
      userLang: 'ar',
    }
  },
  setup() {
    return {
      modules: [Autoplay, Navigation, Pagination ],
    };
  },
  components: { Swiper, SwiperSlide },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    getData(){
      this.hasError = false;
      this.$http.get('/api/reservation/list?page='+this.currentPage).then(res => {
        // console.log(res);
        this.item = res.data;
        this.rows = res.data.rows;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    Nextpage(){
      this.currentPage += 1;
      this.getData();
    },

    Prevpage(){
      this.currentPage -= 1;
      this.getData();
    }
  },
  created(){
    this.getData();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior: 'smooth'});
  }
}
</script>